import "./dragndrop.css";
import {
  React,
  memo,
  toast,
  LoadingSpinner,
  captureeventbaseanalytics,
  FileUploader,
  GetCookie,
  axios,
  useState,
} from "../../Libraries/Media/index";
import { BASEURL, CONTENT_BASEURL, MAX_UPLOAD_FILE_SIZE } from "../../Utils/Constants/constants";
import PropTypes from "prop-types"; // ES6

const fileTypes = ["JPG", "PNG", "mp4"];
const DragnDrop = ({ getAllMediaFunc, handleIndexChange }) => {
  const [totalprogress, settotalprogress] = useState(0);
  const [isloading, setisloading] = useState(false);

  const onUploadProgress = (event) => {
    const percentCompleted = Math.round((event.loaded * 100) / event.total);
    settotalprogress(percentCompleted);
    if (percentCompleted === 100) {
      setTimeout(() => {
        settotalprogress(0);
      }, 400);
    }
  };
  const handleChange = async (file) => {
    if (file) {
      if (file.size >= MAX_UPLOAD_FILE_SIZE) {
        toast.info("Max file upload size is 900Mb");
      } else {
        setisloading(true);
        const mediadata = new FormData();
        mediadata.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        mediadata.append("security_token", await GetCookie("es_token"));
        mediadata.append("upload_type", "File");
        mediadata.append("myFile", file);
        try {
          const returned = await axios.post(
            CONTENT_BASEURL + "addMedia.php",
            mediadata,
            { onUploadProgress }
          );
          if (
            returned.data.status === "true" &&
            returned.data.connection === "true" &&
            returned.data.message === "File uploaded successfully"
          ) {
            setisloading(false);
            captureeventbaseanalytics(
              "Media",
              "postMedia.php upload_type:File RESPONSE",
              returned.data.message
            );
            toast.success(returned.data.message);
            getAllMediaFunc();
            if (file.type !== "video/mp4") {
              handleIndexChange(0);
            } else {
              handleIndexChange(1);
            }
          } else {
            setisloading(false);
            toast.error(returned.data.message);
            captureeventbaseanalytics(
              "Media",
              "postMedia.php upload_type:File RESPONSE",
              returned.data.message
            );
          }
        } catch (error) {
          console.error(error);
          setisloading(false);
          toast.error(error.message);
          captureeventbaseanalytics(
            "Media",
            "postMedia.php upload_type:File RESPONSE",
            error.message
          );
        }
      }
    } else {
      toast.error("No File Selected");
      captureeventbaseanalytics(
        "Media",
        "Drag and Drop Media Section",
        "No File Selected"
      );
    }
  };

  return (
    <>
      {isloading ? <LoadingSpinner totalprogress={totalprogress} /> : null}
      <div className="Fileuploadermedia">
        <FileUploader
          handleChange={handleChange}
          name="file"
          types={fileTypes}
        />
      </div>
    </>
  );
};

DragnDrop.propTypes = {
  getAllMediaFunc: PropTypes.func,
  handleIndexChange: PropTypes.func,
};
export default memo(DragnDrop);
